<template>
  <div>
    <span v-if="data.column.field === 'displayName'">

      <b-form-input
        v-model="data.row.displayName"
        size="sm"
        :placeholder="$tk('ClientPortal.Admin.Targeting.DisplayName')"
      />

    </span>
    <span v-else-if="data.column.field === 'bidIncrement'">
      <div class="d-flex justify-content-center align-items-center">

        <b-form-input
          v-model.number="data.row.bidIncrement"
          type="number"
          size="sm"
          step=".01"
          :placeholder="$tk('ClientPortal.Admin.Targeting.BidIncrement')"
        />

        <b-button
          size="sm"
          variant="link"
          class="p-0 ml-2"
          @click="updateTargeting(data.row)"
        >
          <GjIcon
            name="Save"
            class="text-primary"
          />
        </b-button>
      </div>
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import TargetingService from '@/api/admin/targeting.service'
import notification from '@/mixins/toastification'
import store from '@/store'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  mixins: [notification],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const updateTargeting = async row => {
      try {
        const response = await TargetingService.updateTargetingProperties(row)

        if (response.saved) {
          notification.methods.success(response.message)
        } else {
          notification.methods.error(response.message)
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        await store.dispatch('getTargetingProperties')
      }
    }
    return {
      updateTargeting,
    }
  },
}
</script>

<style scoped>
.form-control{
  color: #052D61;
}
</style>
